import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var _templateObject;
const SvgComponent = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M57 25.95h-.87v-4.37a7 7 0 00-7-7 6.9 6.9 0 00-1.75.23 7 7 0 00-7-6.85 7 7 0 00-7 7V26h-7V15a7 7 0 00-13.93-.12 6.9 6.9 0 00-1.75-.23 7 7 0 00-7 7v4.37H3a3 3 0 000 6h.87v5.47a7 7 0 007 7 6.9 6.9 0 001.75-.23 7 7 0 0013.9-.26V32h7v12a7 7 0 007 7 7 7 0 007-6.85 6.9 6.9 0 001.75.23 7 7 0 007-7v-5.43H57a3 3 0 000-6zM11.81 37.42a1 1 0 01-1.94 0V21.58a1 1 0 111.94 0zM20.52 44a1 1 0 11-1.94 0V15a1 1 0 011.94 0zm20.9 0a1 1 0 11-1.94 0V15a1 1 0 011.94 0zm8.71-6.62a1 1 0 01-1.94 0v-15.8a1 1 0 111.94 0z",
      stroke: "none"
    })]
  });
};
const IconGymFeatureLargeFreeWeightsArea = /*#__PURE__*/styled(SvgComponent).withConfig({
  displayName: "GymFeatureLargeFreeWeightsArea__IconGymFeatureLargeFreeWeightsArea",
  componentId: "sc-1a1vvj9-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  vertical-align: middle;\n"])));

export { IconGymFeatureLargeFreeWeightsArea };
